<template>
    <div 
        class="advisor-button"
        data-tour="advisor-button"
        :class="{ 'expanded': isHovered }"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
        @click="openAdvisorChat"
    >
        <transition name="slide-fade">
            <span v-if="isHovered" class="advisor-text">Talk to an Advisor</span>
        </transition>
        <div class="advisor-icon">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.4 12.6316L25.0305 12.7972C25.593 12.9452 26.0923 13.2868 26.4492 13.7678C26.806 14.2488 26.9999 14.8416 27 15.4519V18.0204C26.9999 18.6307 26.806 19.2235 26.4492 19.7045C26.0923 20.1855 25.593 20.5272 25.0305 20.6752L22.7685 21.2704C22.6536 21.3006 22.5336 21.3027 22.4177 21.2768C22.3019 21.2509 22.1932 21.1975 22.0998 21.1207C22.0065 21.044 21.931 20.9458 21.879 20.8338C21.8271 20.7217 21.8 20.5987 21.8 20.474V12.9983C21.8 12.8735 21.827 12.7503 21.8791 12.6381C21.9311 12.5259 22.0067 12.4277 22.1002 12.3509C22.1937 12.2741 22.3026 12.2208 22.4187 12.195C22.5347 12.1692 22.6548 12.1715 22.7698 12.2019L24.4 12.6316ZM24.4 12.6316V11.9474C24.4 9.04395 23.3043 6.25944 21.3539 4.20641C19.4035 2.15338 16.7583 1 14 1C11.2417 1 8.59647 2.15338 6.64609 4.20641C4.69571 6.25944 3.6 9.04395 3.6 11.9474V12.6316M3.6 12.6316L2.9695 12.7972C2.40702 12.9452 1.90767 13.2868 1.55082 13.7678C1.19396 14.2488 1.00009 14.8416 1 15.4519V18.0204C1.00009 18.6307 1.19396 19.2235 1.55082 19.7045C1.90767 20.1855 2.40702 20.5272 2.9695 20.6752L3.6 20.8421M3.6 12.6316L5.2315 12.2019C5.34644 12.1718 5.46639 12.1696 5.58225 12.1955C5.69812 12.2215 5.80684 12.2748 5.90019 12.3516C5.99353 12.4283 6.06904 12.5265 6.12099 12.6385C6.17294 12.7506 6.19996 12.8736 6.2 12.9983V20.474C6.19996 20.5987 6.17294 20.7217 6.12099 20.8338C6.06904 20.9458 5.99353 21.044 5.90019 21.1207C5.80684 21.1975 5.69812 21.2509 5.58225 21.2768C5.46639 21.3027 5.34644 21.3006 5.2315 21.2704L3.6 20.8421M3.6 20.8421V22.2105C3.6 22.9364 3.87393 23.6325 4.36152 24.1458C4.84912 24.659 5.51044 24.9474 6.2 24.9474H10.1M10.1 24.9474C10.1 24.403 10.3054 23.8809 10.6711 23.4959C11.0368 23.111 11.5328 22.8947 12.05 22.8947H15.95C16.4672 22.8947 16.9632 23.111 17.3289 23.4959C17.6946 23.8809 17.9 24.403 17.9 24.9474C17.9 25.4918 17.6946 26.0139 17.3289 26.3988C16.9632 26.7837 16.4672 27 15.95 27H12.05C11.5328 27 11.0368 26.7837 10.6711 26.3988C10.3054 26.0139 10.1 25.4918 10.1 24.9474Z" stroke="white" stroke-width="2"/>
                </svg>                
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'

export default {
    name: 'AdvisorButton',
    data() {
        return {
            isHovered: false,
        };
    },
    computed: {
        ...GlobalComputed,
        whatsappNumber() {
            return this.appData?.whatsapp_number || '201032325373';
        }
    },
    methods: {
        openAdvisorChat() {
            // Open WhatsApp with the advisor
            const message = encodeURIComponent('Talk to an Advisor');
            const whatsappUrl = `https://wa.me/${this.whatsappNumber}?text=${message}`;
            
            // Open WhatsApp in a new window/tab
            window.open(whatsappUrl, '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
.advisor-button {
    position: fixed;
    right: 0;
    top: 35%;
    transform: translateY(-50%);
    z-index: 999;
    
    display: flex;
    align-items: center;
    justify-content: flex-end;
    
    background: linear-gradient(135deg, #C97008 0%, #E89A3C 100%);
    border-radius: 24px 0 0 24px;
    padding: 16px;
    cursor: pointer;
    box-shadow: -2px 2px 8px rgba(201, 112, 8, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    width: 56px;
    height: 56px;
    overflow: hidden;
    
    &:hover {
        box-shadow: -4px 4px 16px rgba(201, 112, 8, 0.4);
    }
    
    &.expanded {
        width: auto;
        padding: 16px 20px 16px 24px;
    }
    
    @media (max-width: 960px) {
        width: 48px;
        height: 48px;
        padding: 12px;
        
        &.expanded {
            padding: 12px 16px 12px 20px;
        }
    }
}

.advisor-text {
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: white;
    white-space: nowrap;
    margin-right: 12px;
    
    @media (max-width: 960px) {
        font-size: 14px;
        margin-right: 8px;
    }
}

.advisor-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    
    @media (max-width: 960px) {
        width: 20px;
        height: 20px;
        
        svg {
            width: 20px;
            height: 20px;
        }
    }
}

.slide-fade-enter-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter-from {
    transform: translateX(20px);
    opacity: 0;
}

.slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
}
</style>

